import { callFes } from '../index';

export const getCatalogVehicle = async (
  catalogVehicleId: string
): Promise<VehicleIntegration.Components.Schemas.GetCatalogVehicleByCatalogIdResponse> => {
  return callFes.getMiles(`catalog-vehicles/${catalogVehicleId}`);
};
